import { OrganizationManager } from "@entities";
import {
  createPhoneNumberFilter,
  type HyperTableFilter,
} from "@shared/frontend/hyper-table";

const filters: HyperTableFilter<OrganizationManager>[] = [
  { fieldName: "name", id: "name" },
  createPhoneNumberFilter(OrganizationManager, {
    fieldName: "phoneNumber",
    id: "phoneNumber",
  }),
];

export default filters;
